import { IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import L10n from "localization";
import { LuSettings, LuSparkles, LuX } from "react-icons/lu";
import Style from "style";

interface IProps {
  dismiss: () => void;
}

export default function FSRSAnnouncementModal(props: IProps): JSX.Element {
  const { dismiss } = props;

  const handleClose = () => {
    dismiss();
  };

  const containerStyle: React.CSSProperties = {
    padding: "24px",
    textAlign: "center",
    maxWidth: "500px",
    margin: "0 auto",
  };

  const iconStyle: React.CSSProperties = {
    color: Style.colors.actionableFg,
    marginBottom: "16px",
  };

  const titleStyle: React.CSSProperties = {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "16px",
    color: Style.colors.primaryFg,
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: "18px",
    fontWeight: "600",
    color: Style.colors.actionableFg,
    marginBottom: "20px",
  };

  const bodyTextStyle: React.CSSProperties = {
    fontSize: "16px",
    lineHeight: "1.5",
    marginBottom: "16px",
    color: Style.colors.primaryFg,
    textAlign: "left",
  };

  const benefitItemStyle: React.CSSProperties = {
    fontSize: "15px",
    lineHeight: "1.4",
    marginBottom: "12px",
    color: Style.colors.primaryFg,
    textAlign: "left",
    paddingLeft: "8px",
  };

  const settingsHintStyle: React.CSSProperties = {
    fontSize: "14px",
    color: Style.colors.secondaryFg,
    marginTop: "20px",
    padding: "16px",
    backgroundColor: Style.colors.secondaryBg,
    borderRadius: "8px",
    textAlign: "left",
  };

  const settingsIconStyle: React.CSSProperties = {
    verticalAlign: "middle",
    marginRight: "4px",
  };

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{L10n.localize((s) => s.fsrs.announcementTitle)}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleClose} fill="clear">
              <LuX size={24} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={containerStyle}>
          <div style={iconStyle}>
            <LuSparkles size={48} />
          </div>

          <div style={titleStyle}>{L10n.localize((s) => s.fsrs.announcementHeaderTitle)}</div>

          <div style={subtitleStyle}>{L10n.localize((s) => s.fsrs.announcementSubtitle)}</div>

          <div style={bodyTextStyle}>{L10n.localize((s) => s.fsrs.announcementDescription)}</div>

          <div style={benefitItemStyle}>
            • {L10n.localize((s) => s.fsrs.announcementBenefitMemoryRetention)}
          </div>

          <div style={benefitItemStyle}>
            • {L10n.localize((s) => s.fsrs.announcementBenefitOptimizedTime)}
          </div>

          <div style={benefitItemStyle}>
            • {L10n.localize((s) => s.fsrs.announcementBenefitPersonalized)}
          </div>

          <div style={benefitItemStyle}>
            • {L10n.localize((s) => s.fsrs.announcementBenefitScientific)}
          </div>

          <div style={settingsHintStyle}>
            <LuSettings size={16} style={settingsIconStyle} />
            <strong>{L10n.localize((s) => s.fsrs.announcementSettingsHintTitle)}</strong>{" "}
            {L10n.localize((s) => s.fsrs.announcementSettingsHintDescription)}
          </div>

          <IonButton expand="block" onClick={handleClose} style={{ marginTop: "24px" }}>
            {L10n.localize((s) => s.fsrs.announcementButtonClose)}
          </IonButton>
        </div>
      </IonContent>
    </>
  );
}
